// ABOUTME: RTK Query endpoints for the onboarding settings page: the chapter overview and the
// ABOUTME: manual done/skipped override of a step.

import { apiSlice } from "../createApiSlice";

const ONBOARDING_BASE = "/onboarding";
const buildUrl = (endpoint) => ONBOARDING_BASE + endpoint;

const onboardingApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOnboarding: builder.query({
            query: () => ({
                url: buildUrl(''),
                method: 'GET',
            }),
            providesTags: [{ type: 'Onboarding' }],
        }),
        updateOnboardingStep: builder.mutation({
            query: ({ chapter, step, status }) => ({
                url: buildUrl(`/${chapter}/${step}`),
                method: 'PUT',
                body: { status },
            }),
            invalidatesTags: [{ type: 'Onboarding' }],
        }),
    })
});

export const {
    useGetOnboardingQuery,
    useUpdateOnboardingStepMutation,
} = onboardingApiSlice;
